const isDataUrl = (url: string | null | undefined): boolean => {
  return !!(url && url.toLowerCase().startsWith('data:'));
};

export default isDataUrl;
